import { Answer } from "@modules/health-screening/health-screening-score-details/health-screening-score-details.component";
import { WpaArea, WpaResult } from "../interfaces/wpa";

export const MOCK_QUESTIONS: Answer[] = [
	{
		Id: "1",
		IsSubQuestion: false,
		AreaName: "Physical Health",
		Area: "Physical Health",
		SubArea: "Exercise Frequency",
		MaxScore: 100,
		MinScore: 30,
		Score: 75,
		Order: 1,
		QuestionAnswerObj:
			"<p>The person exercises 3 times a week for 45 minutes each session.</p>",
		QuestionText: "How frequently does the person engage in physical exercise?",
		EnergyType: 0,
	},
	{
		Id: "2",
		IsSubQuestion: false,
		AreaName: "Physical Health",
		Area: "Mental Health",
		SubArea: "Stress Levels",
		MaxScore: 100,
		MinScore: 40,
		Score: 60,
		Order: 2,
		QuestionAnswerObj:
			"<p>The person reports feeling stressed on most days, especially during work hours.</p>",
		QuestionText: "How frequently does the person experience stress?",
		EnergyType: null,
	},
	{
		Id: "3",
		IsSubQuestion: false,
		AreaName: "Physical Health",
		Area: "Physical Health",
		SubArea: "Dietary Habits",
		MaxScore: 100,
		MinScore: 30,
		Score: 85,
		Order: 3,
		QuestionAnswerObj:
			"<p>The person follows a balanced diet with plenty of vegetables, fruits, and lean proteins.</p>",
		QuestionText: "How healthy is the person’s diet?",
		EnergyType: 0,
	},
	{
		Id: "4",
		IsSubQuestion: false,
		AreaName: "Physical Health",
		Area: "Mental Health",
		SubArea: "Sleep Quality",
		MaxScore: 100,
		MinScore: 40,
		Score: 70,
		Order: 4,
		QuestionAnswerObj:
			"<p>The person gets an average of 7 hours of sleep each night, but experiences occasional insomnia.</p>",
		QuestionText: "How would you rate the quality of the person’s sleep?",
		EnergyType: 1,
	},
	{
		Id: "5",
		IsSubQuestion: false,
		AreaName: "Physical Health",
		Area: "Physical Health",
		SubArea: "Chronic Illness",
		MaxScore: 100,
		MinScore: 50,
		Score: 90,
		Order: 5,
		QuestionAnswerObj:
			"<p>The person has no chronic illnesses or long-term medical conditions.</p>",
		QuestionText:
			"Does the person have any chronic illnesses or long-term health conditions?",
		EnergyType: null,
	},
	{
		Id: "6",
		IsSubQuestion: false,
		AreaName: "Physical Health",
		Area: "Mental Health",
		SubArea: "Anxiety Levels",
		MaxScore: 100,
		MinScore: 40,
		Score: 80,
		Order: 6,
		QuestionAnswerObj:
			"<p>The person experiences moderate anxiety during stressful events, but can manage it effectively.</p>",
		QuestionText:
			"How severe are the person’s anxiety levels in everyday situations?",
		EnergyType: null,
	},
	{
		Id: "7",
		IsSubQuestion: false,
		AreaName: "Physical Health",
		Area: "Physical Health",
		SubArea: "Hydration",
		MaxScore: 100,
		MinScore: 40,
		Score: 75,
		Order: 7,
		QuestionAnswerObj:
			"<p>The person drinks 2 liters of water daily and stays hydrated throughout the day.</p>",
		QuestionText: "How well does the person stay hydrated?",
		EnergyType: 1,
	},
	{
		Id: "8",
		IsSubQuestion: false,
		AreaName: "Physical Health",
		Area: "Mental Health",
		SubArea: "Social Support",
		MaxScore: 100,
		MinScore: 50,
		Score: 85,
		Order: 8,
		QuestionAnswerObj:
			"<p>The person has a strong support network of friends and family who provide emotional support.</p>",
		QuestionText: "How strong is the person’s social support system?",
		EnergyType: 0,
	},
	{
		Id: "9",
		IsSubQuestion: false,
		AreaName: "Physical Health",
		Area: "Physical Health",
		SubArea: "Smoking Habits",
		MaxScore: 100,
		MinScore: 20,
		Score: 60,
		Order: 9,
		QuestionAnswerObj:
			"<p>The person occasionally smokes socially but does not smoke regularly.</p>",
		QuestionText: "Does the person smoke, and if so, how frequently?",
		EnergyType: null,
	},
	{
		Id: "10",
		IsSubQuestion: false,
		AreaName: "Physical Health",
		Area: "Mental Health",
		SubArea: "Depression Levels",
		MaxScore: 100,
		MinScore: 40,
		Score: 55,
		Order: 10,
		QuestionAnswerObj:
			"<p>The person occasionally experiences mild depression but has coping mechanisms in place.</p>",
		QuestionText: "How severe are the person’s depression levels?",
		EnergyType: null,
	},
];

function getRandom<T>(array: T[], count: number): T[] {
	const shuffled = [...array];
	for (let i = shuffled.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
	}
	return shuffled.slice(0, count);
}

export const MOCK_AREAS: WpaArea[] = [
	{
		id: "1001",
		name: [{ language: "en", text: "Physical Health" }],
		questions: getRandom(MOCK_QUESTIONS, 5),
	},
	{
		id: "1002",
		name: [{ language: "en", text: "Mental Health" }],
		questions: getRandom(MOCK_QUESTIONS, 5),
	},
	{
		id: "1003",
		name: [{ language: "en", text: "Stress Management" }],
		questions: getRandom(MOCK_QUESTIONS, 5),
	},
	{
		id: "1004",
		name: [{ language: "en", text: "Diet and Nutrition" }],
		questions: getRandom(MOCK_QUESTIONS, 5),
	},
	{
		id: "1005",
		name: [{ language: "en", text: "Sleep and Rest" }],
		questions: getRandom(MOCK_QUESTIONS, 5),
	},
];

function getRandomDate(start: Date, end: Date): Date {
	const randomTime =
		start.getTime() + Math.random() * (end.getTime() - start.getTime());
	return new Date(randomTime);
}

export const MOCK_RESULTS: WpaResult[] = [
	{
		id: "123",
		date: getRandomDate(new Date(2022, 0, 1), new Date(2025, 0, 1)),
		groups: [MOCK_AREAS[0], MOCK_AREAS[1]],
	},
	{
		id: "124",
		date: getRandomDate(new Date(2022, 0, 1), new Date(2025, 0, 1)),
		groups: [MOCK_AREAS[2], MOCK_AREAS[4]],
	},
	{
		id: "125",
		date: getRandomDate(new Date(2022, 0, 1), new Date(2025, 0, 1)),
		groups: [MOCK_AREAS[1], MOCK_AREAS[3]],
	},
	{
		id: "126",
		date: getRandomDate(new Date(2022, 0, 1), new Date(2025, 0, 1)),
		groups: [MOCK_AREAS[0], MOCK_AREAS[2]],
	},
	{
		id: "127",
		date: getRandomDate(new Date(2022, 0, 1), new Date(2025, 0, 1)),
		groups: [MOCK_AREAS[1], MOCK_AREAS[4]],
	},
	{
		id: "128",
		date: getRandomDate(new Date(2022, 0, 1), new Date(2025, 0, 1)),
		groups: [MOCK_AREAS[3], MOCK_AREAS[0]],
	},
	{
		id: "129",
		date: getRandomDate(new Date(2022, 0, 1), new Date(2025, 0, 1)),
		groups: [MOCK_AREAS[4], MOCK_AREAS[2]],
	},
	{
		id: "130",
		date: getRandomDate(new Date(2022, 0, 1), new Date(2025, 0, 1)),
		groups: [MOCK_AREAS[0], MOCK_AREAS[1]],
	},
];
